import { config } from '@services/context';
import { createContext, useCallback, useContext } from 'react';

interface TelemetryContextType {
  collectMetric: (
    metricName: string,
    value: number,
    unit: string,
    context: Record<string, any>,
    userDetails: { userId?: string; email?: string; fullName?: string },
    tags: string[]
  ) => void;
}

export const TelemetryContext = createContext<TelemetryContextType | undefined>(undefined);

export const useTelemetry = () => {
  const context = useContext(TelemetryContext);
  if (!context) {
    throw new Error('useTelemetry must be used within a TelemetryProvider');
  }
  return context;
};

export const TelemetryProvider = ({ children }: { children: React.ReactNode }) => {
  const isCollectingTelemetry = config.isCollectingTelemetry;
  const timestamp = Date.now();

  const collectMetric = useCallback(
    (
      metricName: string,
      value: number,
      unit: string,
      context: Record<string, any>,
      userDetails: { userId?: string; email?: string; fullName?: string } | null,
      tags: string[]
    ) => {
      if (!isCollectingTelemetry) {
        return;
      }

      const metric = {
        name: metricName,
        value: value,
        unit: unit,
        timestamp: timestamp,
        context: context,
        userDetails,
        tags: tags,
      };
      console.log('[Telemetry]', metric);

      //TODO: Send metric to backend once the infrastructure is ready
    },
    [isCollectingTelemetry]
  );

  return <TelemetryContext.Provider value={{ collectMetric }}>{children}</TelemetryContext.Provider>;
};
